import request from '@/utils/request'

export function list(params) {
  return request({
    url: '/menus',
    method: 'get',
    params,
  })
}
